import "./i18n"; // Initialize i18next configuration
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "@netapp/bxp-design-system-react/dist/index.css";
import "@netapp/bxp-style/css/reset.css";
import { ThemeProvider } from "@netapp/bxp-design-system-react";
import "@netapp/bxp-style/css/bluexp.css";
import "@netapp/bxp-style/css/reset.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ThemeProvider isRoot={true} theme={"light"}>
      <App />
    </ThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
